import { useState, useCallback, useRef, useEffect } from 'react';

const screens = {
    small: '384px',
    medium: '600px',
    tablet: '768px',
    'large-min': '1024px',
    large: '1100px',
    'xl-special': '1200px',
    '2xl-special': '1488px',
};

function useResize(callback) {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    useEffect(() => {
        window.addEventListener('resize', callbackRef.current);

        return () => {
            window.removeEventListener('resize', callbackRef.current);
        };
    }, []);
}

function handleUpdate(breakpoint) {
    const matchMediaResponse = window.matchMedia(
        `(min-width: ${screens[breakpoint]})`
    );

    return matchMediaResponse.matches;
}

/**
 * uniqByKeepFirst
 * @param {typeof screens} breakpoint
 * @param {boolean} ssr
 */
function useBreakpoint(breakpoint, ssr = true) {
    const [isMatch, setIsMatch] = useState < boolean > (
        ssr
            ? typeof window !== 'undefined'
                ? handleUpdate(breakpoint)
                : false
            : false
    );

    const checkSize = useCallback(() => {
        const matchMediaResponse = handleUpdate(breakpoint);
        setIsMatch(matchMediaResponse);
    }, [breakpoint]);

    const checkSizeRef = useRef(checkSize);
    checkSizeRef.current = checkSize;

    useEffect(() => {
        checkSizeRef.current();
    }, []);

    useResize(checkSizeRef.current);

    return isMatch;
};

export default useBreakpoint;